// From Vssf/WebPlatform/Platform/Scripts/VSS/Utils/UI.ts
/// <amd-module name="VSS/Features/SignalR/Common" />
export interface IBrowserInformation {
    chrome?: boolean;
}

class BrowserInformation {
    private static _instance: BrowserInformation;
    private _browserInformation: IBrowserInformation;

    public static getInstance(): BrowserInformation {
        if (!BrowserInformation._instance) {
            BrowserInformation._instance = new BrowserInformation();
            this._instance._initialize();
        }

        return BrowserInformation._instance;
    }

    public getBrowserInformation(): IBrowserInformation {
        return this._browserInformation;
    }

    private _initialize() {
        if (!this._browserInformation) {
            this._browserInformation = {};
            const iOS = /iphone|ipod|ipad/i.exec(navigator.userAgent);
            if (iOS) {
                return;
            }

            const edge = /edge\/([\d+.]+)/i.exec(navigator.userAgent);
            if (edge) {
                return;
            }

            const msie = /msie ([\d+.]+)/i.exec(navigator.userAgent);
            if (msie) {
                return;
            }
            
            var chrome = /chrome\/([\d.]+)/i.exec(navigator.userAgent);
            if (chrome) {
                this._browserInformation.chrome = true;
                return;
            }
        }
    }
}

export function isChrome(): boolean {
    return !!BrowserInformation.getInstance().getBrowserInformation().chrome;
}

export function getRandomNumberBetweenRange(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
